function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { ConfigurationAPI } from '../apis/ConfigurationAPI';
var ThemeDetailsContext = /*#__PURE__*/ createContext({
    stateImages: null,
    isLoading: false,
    fetchThemeDetails: function () {
        var _fetchThemeDetails = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            return _context.a(2);
                    }
            }, _callee);
        }));
        function fetchThemeDetails() {
            return _fetchThemeDetails.apply(this, arguments);
        }
        return fetchThemeDetails;
    }()
});
export var ThemeDetailsProvider = function ThemeDetailsProvider(_ref) {
    var children = _ref.children;
    var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), stateImages = _useState2[0], setStateImages = _useState2[1];
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var fetchThemeDetails = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
        var bundle, _iterator, _step, _config$items, config, themeItem, _details$industryDeta, _details$industryDeta2, details, _t, _t2;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        if (!(stateImages || isLoading)) {
                            _context2.n = 1;
                            break;
                        }
                        return _context2.a(2);
                    case 1:
                        setIsLoading(true);
                        _context2.p = 2;
                        _context2.n = 3;
                        return ConfigurationAPI.getConfigurations('AppConfiguration');
                    case 3:
                        bundle = _context2.v;
                        if (!(bundle !== null && bundle !== void 0 && bundle.resource)) {
                            _context2.n = 10;
                            break;
                        }
                        _iterator = _createForOfIteratorHelper(bundle.resource);
                        _context2.p = 4;
                        _iterator.s();
                    case 5:
                        if ((_step = _iterator.n()).done) {
                            _context2.n = 7;
                            break;
                        }
                        config = _step.value;
                        themeItem = (_config$items = config.items) === null || _config$items === void 0 ? void 0 : _config$items.find(function (item) {
                            return item.key === 'themeDetails';
                        });
                        if (!(themeItem && _typeof(themeItem.value) === 'object')) {
                            _context2.n = 6;
                            break;
                        }
                        details = themeItem.value;
                        setStateImages((_details$industryDeta = details === null || details === void 0 || (_details$industryDeta2 = details.industryDetails) === null || _details$industryDeta2 === void 0 ? void 0 : _details$industryDeta2.stateImages) !== null && _details$industryDeta !== void 0 ? _details$industryDeta : null);
                        return _context2.a(3, 7);
                    case 6:
                        _context2.n = 5;
                        break;
                    case 7:
                        _context2.n = 9;
                        break;
                    case 8:
                        _context2.p = 8;
                        _t = _context2.v;
                        _iterator.e(_t);
                    case 9:
                        _context2.p = 9;
                        _iterator.f();
                        return _context2.f(9);
                    case 10:
                        _context2.n = 12;
                        break;
                    case 11:
                        _context2.p = 11;
                        _t2 = _context2.v;
                        console.warn('Failed to fetch theme details:', _t2);
                    case 12:
                        _context2.p = 12;
                        setIsLoading(false);
                        return _context2.f(12);
                    case 13:
                        return _context2.a(2);
                }
        }, _callee2, null, [[4, 8, 9, 10], [2, 11, 12, 13]]);
    })), [stateImages, isLoading]);
    var contextValue = useMemo(function () {
        return {
            stateImages: stateImages,
            isLoading: isLoading,
            fetchThemeDetails: fetchThemeDetails
        };
    }, [stateImages, isLoading, fetchThemeDetails]);
    return /*#__PURE__*/ React.createElement(ThemeDetailsContext.Provider, {
        value: contextValue
    }, children);
};
/**
 * Hook to access state images and fetch function
 */
export var useThemeDetails = function useThemeDetails() {
    return useContext(ThemeDetailsContext);
};
